import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';
import { Cake } from 'lucide-react';
import ListCard from '../List/components/ListCard';
import useGetUser from '../User/hooks/useGetUser';
import useGetLists from '../List/hooks/useGetLists';
import NextEvents from '../Event/components/NextEvents';
import { daysToNextBirthDay } from '@/utils/date';
import ConfettiExplosion from 'react-confetti-explosion';
import ListAddModal from '../List/components/ListAddModal';

const Home = () => {
	const { t } = useTranslation();
	const { user } = useGetUser();
	const { lists } = useGetLists();

	const daysToBirthday = daysToNextBirthDay(user?.birthday || '');
	const isToday = daysToBirthday === 365;
	// const isToday = true;

	return (
		<div className="flex w-full flex-col">
			<Card className="mb-6">
				<CardHeader>
					<CardTitle className="text-2xl">
						{t('home.title', { name: user?.firstname })}
					</CardTitle>
				</CardHeader>
				<CardContent>
					<p className="flex gap-1 pb-2">
						<Cake className="mr-2" />
						{isToday ? (
							<div className="text-lg">
								{t('home.birthday')}
								<ConfettiExplosion
									className="absolute left-1/2 top-1/3"
									particleCount={200}
									force={0.7}
								/>
							</div>
						) : (
							t('home.message', {
								count: daysToBirthday,
							})
						)}
					</p>
				</CardContent>
			</Card>
			<div className="mt-4 flex flex-col gap-3 pb-24">
				<h2 className="mb-2 text-xl">{t('home.lists')}</h2>
				<div className="mb-2 flex flex-col gap-2">
					{lists.map((list) => (
						<ListCard
							key={list.id}
							id={list.id}
							name={list.name}
							date={user?.birthday || ''}
						/>
					))}
				</div>
				<div className="w-full sm:max-w-md">
					<ListAddModal />
				</div>
				<NextEvents />
			</div>
		</div>
	);
};

export default Home;
